"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvancedSearchNode = void 0;
const NODE_TYPE = 'ADVANCED-SEARCH';
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
/**
 * the purpose of this node is to provide a way to look up multiple aggregate ids based on the value of a single attribute
 */
class AdvancedSearchNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this.asynchronousResolver = async (nodeMap) => {
            var _a, _b;
            const result = {
                exists: false,
                itemsArray: [],
                successfulLookup: false,
            };
            if ((_a = this.accessorMap) === null || _a === void 0 ? void 0 : _a.ADVANCED_SEARCH) {
                const inputs = await this.asynchronousResolveInputs(nodeMap);
                try {
                    const results = await ((_b = this.accessorMap) === null || _b === void 0 ? void 0 : _b.ADVANCED_SEARCH(this.config.schema, this.config.aggregateResults, this.config.selectValues, this.config.groupBy, this.config.joins, this.config.recordType, this.config.whereClause, this.config.havingClause, this.config.orderBy, this.config.maxResults, inputs));
                    return {
                        exists: results.length > 0,
                        itemsArray: results,
                        successfulLookup: true,
                    };
                }
                catch (e) {
                    console.log('Error in advanced search', e);
                }
            }
            // Accessor was not available, can not run this transform
            return result;
        };
        this.synchronousResolver = (_nodeMap) => {
            throw new Error('Aggregate search is not allowed as a synchronously resolving node');
        };
        //TODO: Build the interface definition from the given schema....but what is our schema
        this._interfaceDefinition = Schema;
    }
    // we override the schema definition here so that we can provide it based on the selected value
    get interfaceDefinition() {
        var _a, _b, _c, _d, _e, _f, _g;
        //grab the available aggregate types if available
        const aggregateTypes = this.schemaLookup.getAggregates && this.schemaLookup.getAggregates();
        const relationships = this.schemaLookup.getRelationships && this.schemaLookup.getRelationships();
        // grab the available event schemas
        let aggregateSchema = null;
        if ((_a = this.config) === null || _a === void 0 ? void 0 : _a.recordType) {
            // we use this trick to get a full copy of the schema. This may end up being too slow, but let's try for now.
            aggregateSchema = JSON.parse(JSON.stringify(this.schemaLookup.getSchema(this.config.recordType) || {}));
            if (this.config.schema === 'Analytic' && aggregateSchema.properties) {
                aggregateSchema.properties.recordActiveFrom = {
                    type: 'string',
                    format: 'date-time',
                };
                aggregateSchema.properties.recordActiveTo = {
                    type: 'string',
                    format: 'date-time',
                };
            }
        }
        let attributeNames = aggregateSchema && aggregateSchema.properties
            ? Object.keys(aggregateSchema.properties).map(p => `"record"."${p}"`)
            : [];
        let extraSelects = [];
        let extraJoins = [];
        if ((_b = this.config.joins) === null || _b === void 0 ? void 0 : _b.length) {
            for (const join of this.config.joins) {
                if (join.length) {
                    const match = join.match(/\((\w+)\) AS "(\w+)"/);
                    const recordType = match[1];
                    const name = match[2];
                    const localSchema = JSON.parse(JSON.stringify(this.schemaLookup.getSchema(recordType) || {}));
                    if (this.config.schema === 'Analytic' && localSchema.properties) {
                        localSchema.properties.recordActiveFrom = {
                            type: 'string',
                            format: 'date-time',
                        };
                        localSchema.properties.recordActiveTo = {
                            type: 'string',
                            format: 'date-time',
                        };
                    }
                    attributeNames = attributeNames.concat(Object.keys(localSchema.properties).map(n => `"${name}"."${n}" AS "${name}${n}"`));
                    extraSelects = extraSelects.concat(...Object.keys((localSchema === null || localSchema === void 0 ? void 0 : localSchema.properties) || {}).reduce((prev, curr) => {
                        let newItems = [];
                        const currentSchema = localSchema.properties[curr];
                        if (currentSchema.type === 'number') {
                            newItems = newItems.concat(`MIN("${name}"."${curr}") AS "min${name}${curr}"`, `MAX("${name}"."${curr}") AS "max${name}${curr}"`, `AVG("${name}"."${curr}") AS "avg${name}${curr}"`, `SUM("${name}"."${curr}") AS "sum${name}${curr}"`, `STDDEV("${name}"."${curr}") AS "stddev${name}${curr}"`);
                        }
                        if (currentSchema.type === 'string') {
                            newItems = newItems.concat(`MIN("${name}"."${curr}") AS "min${name}${curr}"`, `MAX("${name}"."${curr}") AS "max${name}${curr}"`);
                        }
                        return prev.concat(...newItems);
                    }, []));
                    extraJoins = extraJoins.concat((_c = relationships === null || relationships === void 0 ? void 0 : relationships[recordType]) === null || _c === void 0 ? void 0 : _c.reduce((prev, curr) => {
                        return prev.concat(`LEFT JOIN ${name}.${curr.relatedColumn} (${curr.relatedRecordType}) AS "${name}LJ${curr.relatedColumn}"`, `INNER JOIN ${name}.${curr.relatedColumn} (${curr.relatedRecordType}) AS "${name}IJ${curr.relatedColumn}"`);
                    }, []));
                }
            }
        }
        const outputProps = Object.assign(Object.assign({}, (_d = this.config.selectValues) === null || _d === void 0 ? void 0 : _d.reduce((prev, curr) => {
            if (!curr || !curr.length) {
                return prev;
            }
            const split = curr.split(' AS ');
            const split2 = split[split.length - 1].replace(/"/g, '').split('.');
            const propName = split2[split2.length - 1];
            const aggregatePropType = (attributeNames.length && aggregateSchema.properties[propName]) || { type: 'Number' };
            return Object.assign(Object.assign({}, prev), { [propName]: aggregatePropType });
        }, {})), (this.config.aggregateResults === 'Yes'
            ? (_e = this.config.groupBy) === null || _e === void 0 ? void 0 : _e.reduce((prev, curr) => {
                if (!curr || !curr.length) {
                    return prev;
                }
                const split = curr.split(' AS ');
                const split2 = split[split.length - 1].replace(/"/g, '').split('.');
                const propName = split2[split2.length - 1];
                const aggregatePropType = (attributeNames.length && aggregateSchema.properties[propName]) || {
                    type: 'Number',
                };
                return Object.assign(Object.assign({}, prev), { [propName]: aggregatePropType });
            }, {})
            : {}));
        //set up the basic outputParams schema
        const OutputParams = {
            type: 'object',
            properties: {
                exists: { type: 'boolean', description: 'Exists?' },
                successfulLookup: { type: 'boolean', description: 'Lookup Successful?' },
                itemsArray: {
                    type: 'array',
                    items: { type: 'object', properties: outputProps },
                    description: 'Aggregate Object Array',
                },
            },
        };
        const params = (_f = ((this.config.whereClause || '') +
            ' ' +
            (this.config.aggregateResults === 'Yes' && this.config.havingClause ? this.config.havingClause : ''))
            .match(/(^|[^:]):\w+/g)) === null || _f === void 0 ? void 0 : _f.map(val => val.substring(1).replace(':', ''));
        const InputParams = {
            type: 'object',
            properties: Object.assign({}, params === null || params === void 0 ? void 0 : params.reduce((prev, curr) => (Object.assign(Object.assign({}, prev), { [curr]: { type: 'string' } })), {})),
        };
        return Object.assign(Object.assign({}, Schema), { InputParams: InputParams, OutputParams: OutputParams, ConfigParams: {
                type: 'object',
                properties: Object.assign(Object.assign(Object.assign(Object.assign({ schema: {
                        description: 'Schema Type',
                        type: 'string',
                        enum: ['Final Projection', 'Analytic'],
                        default: 'Final Projection',
                    }, recordType: {
                        description: 'Record Type',
                        type: 'string',
                        enum: aggregateTypes || undefined,
                    }, aggregateResults: {
                        description: 'Aggregate Results?',
                        type: 'string',
                        enum: ['Yes', 'No'],
                        default: 'No',
                    } }, (this.config.aggregateResults === 'Yes'
                    ? {
                        groupBy: {
                            type: 'array',
                            description: 'Group By',
                            items: {
                                description: 'Value',
                                type: 'string',
                                enum: attributeNames.map(n => {
                                    const part = n.split(' AS ')[0];
                                    if (part.includes('"')) {
                                        return part;
                                    }
                                    else {
                                        return `"record"."${part}"`;
                                    }
                                }),
                            },
                        },
                    }
                    : {})), { selectValues: {
                        type: 'array',
                        description: 'Select Values',
                        items: {
                            description: 'Value',
                            type: 'string',
                            enum: this.config.aggregateResults === 'Yes'
                                ? Object.keys((aggregateSchema === null || aggregateSchema === void 0 ? void 0 : aggregateSchema.properties) || {})
                                    .reduce((prev, curr) => {
                                    let newItems = [];
                                    const currentSchema = aggregateSchema.properties[curr];
                                    if (currentSchema.type === 'number') {
                                        newItems = newItems.concat(`MIN("record"."${curr}") AS "min${curr}"`, `MAX("record"."${curr}") AS "max${curr}"`, `AVG("record"."${curr}") AS "avg${curr}"`, `SUM("record"."${curr}") AS "sum${curr}"`, `STDDEV("record"."${curr}") AS "stddev${curr}"`);
                                    }
                                    if (currentSchema.type === 'string') {
                                        newItems = newItems.concat(`MIN("record"."${curr}") AS "min${curr}"`, `MAX("record"."${curr}") AS "max${curr}"`);
                                    }
                                    return prev.concat(...newItems);
                                }, ['COUNT(*) AS "count"'])
                                    .concat(...extraSelects)
                                : attributeNames,
                        },
                    }, joins: {
                        type: 'array',
                        description: 'Joins',
                        items: {
                            description: 'Value',
                            type: 'string',
                            enum: (_g = relationships === null || relationships === void 0 ? void 0 : relationships[this.config.recordType]) === null || _g === void 0 ? void 0 : _g.reduce((prev, curr) => {
                                return prev.concat(`LEFT JOIN record.${curr.relatedColumn} (${curr.relatedRecordType}) AS "recordLJ${curr.relatedColumn}"`, `INNER JOIN record.${curr.relatedColumn} (${curr.relatedRecordType}) AS "recordIJ${curr.relatedColumn}"`);
                            }, []).concat(...extraJoins),
                        },
                    }, orderBy: {
                        type: 'array',
                        description: 'Order By',
                        items: {
                            description: 'Value',
                            type: 'string',
                            enum: (this.config.aggregateResults === 'Yes'
                                ? Object.keys(outputProps).map(k => `"${k}"`)
                                : attributeNames.map(n => n.split(' AS ')[0])).reduce((prev, curr) => {
                                return prev.concat(`${curr} ASC`, `${curr} DESC`);
                            }, []),
                        },
                    }, whereClause: {
                        description: 'Where Clause',
                        type: 'string',
                    } }), (this.config.aggregateResults === 'Yes'
                    ? {
                        havingClause: {
                            description: 'Having Clause',
                            type: 'string',
                        },
                    }
                    : {})), { maxResults: {
                        description: 'Maximum Results',
                        type: 'number',
                    } }),
            } });
    }
}
exports.AdvancedSearchNode = AdvancedSearchNode;
AdvancedSearchNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Advanced Search',
    isIdempotent: false,
    primaryCategory: 'Data Lookup',
};
//# sourceMappingURL=AdvancedSearch.js.map